<template>
  <div class="alert alert-dismissible fade" :class="classObject" role="alert">
    <template v-if="isFinish">
      <strong>Your report is ready!</strong>&nbsp;&nbsp;<a
        :href="url"
        title="Download">Click here to download <i class="fa fa-download"></i></a>
    </template>
    <template v-else-if="isError">
      <strong>Failed!</strong> An error occured when generating your report.
    </template>
    <template v-else-if="isOnProgress">
      Please wait, your report is still on progress. <br/>
      <strong class="small">{{ status }}</strong>
      <b-progress :value="100" variant="info" striped :animated="true"></b-progress>
    </template>
    <button @click.prevent="dismiss"
      type="button"
      class="close"
      data-dismiss="alert"
      title="Close"
      aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
  </div>
</template>
<script>

import { titleCase } from 'change-case';

const onProgressStates = [
  'PROCESSING',
  'COLLECTING_DATA',
  'EXPORTING',
];

export default {
  data() {
    const onProgress = onProgressStates
      .indexOf(this.state) > -1;

    return {
      classObject: {
        show: true,
        'alert-primary': onProgress,
        'alert-success': this.state === 'FINISH',
        'alert-warning': false,
        'alert-danger': this.state === 'ERROR',
      },
    };
  },
  props: {
    state: {
      type: String,
      default: 'PROCESSING',
    },
    progress: {
      type: Number,
      default: 0,
    },
    url: String,
  },
  watch: {
    state() {
      this.classObject['alert-primary'] = this.isOnProgress;
      this.classObject['alert-success'] = this.isFinish;
      this.classObject['alert-danger'] = this.isError;
    },
  },
  computed: {
    status() {
      return titleCase(this.state.replace('_', ' '));
    },
    isOnProgress() {
      return onProgressStates
        .indexOf(this.state) > -1;
    },
    isFinish() {
      return this.state === 'FINISH';
    },
    isError() {
      return this.state === 'ERROR';
    },
  },
  methods: {
    dismiss() {
      this.classObject.show = false;
      this.$emit('dismiss');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ReportProgress.vue